import { render } from "./QuestionsUpdated.vue?vue&type=template&id=62474c68&scoped=true"
import script from "./QuestionsUpdated.vue?vue&type=script&lang=js"
export * from "./QuestionsUpdated.vue?vue&type=script&lang=js"

import "./QuestionsUpdated.vue?vue&type=style&index=0&id=62474c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62474c68"]])

export default __exports__